module.exports = __webpack_public_path__ + "assets/img/1546.170826ea.png";